import { Directive, HostListener, inject } from '@angular/core';

import { FichaTecnicaService } from '../services/ficha-tecnica.service';

@Directive({
    selector: '[appFichaTecnica]',
    standalone: true,
})
export class FichaTecnicaDirective {
    private readonly fichaTecnicaService = inject(FichaTecnicaService);

    @HostListener('click', ['$event'])
    public aoClicar(evento: Event): void {
        evento.preventDefault();
        this.fichaTecnicaService.abrirEmNovaAba();
    }
}
